import { MdrCustomerPanelGzDataProvider } from '../dataProvider/MdrCustomerPanelGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class MdrCustomerPanelDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, MdrCustomerPanelGzDataProvider);
  }
}
